import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface AppError {
  displayType: 'dialog' | 'notFound' | 'alert';
  message?: string;
}

export interface AppState {
  currentError?: AppError;
  showGroupOrderStatusDialog: boolean;
}

const initialState: AppState = {
  showGroupOrderStatusDialog: false
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setError: (state, action: PayloadAction<AppError>) => {
      state.currentError = action.payload;
    },
    clearError: state => {
      delete state.currentError;
    },
    showGroupOrderStatusDialog: (state, action: PayloadAction<boolean>) => {
      state.showGroupOrderStatusDialog = action.payload;
    }
  }
});

export const {setError, clearError, showGroupOrderStatusDialog} =
  appSlice.actions;

export const {reducer} = appSlice;
